import { unique } from 'src/libs/helper'
import {
  CustomRoleDetailEntity,
  CustomRoleFormEntity,
  CustomRoleRequest,
  CustomRolesResponse,
} from 'src/types'

export const CustomRoleTranslator = {
  toDetailEntities: (response: CustomRolesResponse): CustomRoleDetailEntity[] => {
    const { roles } = response
    return (
      roles?.map(role => ({
        id: role.id,
        name: role.name,
        selectedPolicyIds: unique(role.policyIds),
        selectedAssignUserIds: unique(role.users?.map(user => user.id)) ?? [],
      })) ?? []
    )
  },

  toRequest: (formEntity: CustomRoleFormEntity): CustomRoleRequest => {
    const { name, assignUserIds, policyIds } = formEntity
    return {
      name,
      userIds: unique(assignUserIds),
      policyIds: unique(policyIds),
    }
  },
} as const
